angular.module('leanlaw').factory('originationDefinition', ['$q', 'singleRequest', 'clientMatterManager', function ($q, singleRequest) {
  const cancel = params => {
    singleRequest.cancel('compensation');
  };
  const load = async ({
    query,
    filter
  }) => {
    const request = {
      ...query,
      primary: 'users',
      data: 'payments',
      status: 'all',
      scope: 'all',
      accountFilter: 'originating'
    };
    const report = await singleRequest.apiCall('origination-report', true).getReport(request);

    // create rows and subrows for group of users and items
    const rows = report.users.map(user => {
      return {
        id: user.user && user.user.id,
        label: user.user && user.user.name,
        values: {
          user: {
            value: `${user.user.name} (${user.user.initials})`
          },
          services: {
            value: user.data.collected.servicesTotal
          },
          expenses: {
            value: user.data.collected.expensesTotal
          },
          total: {
            value: user.data.collected.total
          },
          origination: {
            value: user.data.origination.originatorDebit
          }
        }
      };
    });
    if (report.unallocated?.collected.total) {
      const label = 'No Originator';
      rows.push({
        id: undefined,
        label,
        values: {
          user: {
            value: label,
            italic: true
          },
          services: {
            value: report.unallocated.collected.servicesTotal
          },
          expenses: {
            value: report.unallocated.collected.expensesTotal
          },
          total: {
            value: report.unallocated.collected.total
          },
          origination: {
            value: undefined
          }
        }
      });
    }
    console.log(rows);
    return {
      rows
    };
  };
  const structure = ({
    params,
    me
  }) => {
    return {
      sort: 'user',
      label: `Origination`,
      // subrow: {
      //   label: 'Detail',
      //   default: true,
      //   title: true,
      // },
      totals: {
        rows: true,
        totalLabelCells: 4
      },
      showFilters: {
        distribution: true,
        dateRange: true
      },
      columns: [{
        id: 'user',
        label: 'User'
      }, {
        id: 'services',
        label: 'Collected Services',
        filter: 'amount',
        number: true,
        total: false
      }, {
        id: 'expenses',
        label: 'Collected Expenses',
        filter: 'amount',
        number: true,
        total: false
      }, {
        id: 'total',
        label: 'Collected Total',
        filter: 'amount',
        number: true,
        total: false
      }, {
        id: 'origination',
        label: 'Origination',
        filter: 'amount',
        number: true
      }]
    };
  };
  return {
    structure,
    load,
    cancel
  };
}]);